export default __webpack_public_path__ + "static/media/notting_4.f2712b09.jpg";